import { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useCookieConsent } from '../hooks/useCookieConsent';

export default function CookieConsentBanner() {
  const { consent, hasConsented, acceptAll, rejectAll, updatePreferences } = useCookieConsent();
  const [showPreferences, setShowPreferences] = useState(false);
  const [analyticsToggle, setAnalyticsToggle] = useState(consent?.analytics ?? false);

  if (hasConsented) return null;

  const handleSavePreferences = () => {
    updatePreferences({ analytics: analyticsToggle });
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        p: { xs: 2, sm: 3 },
        borderRadius: 0,
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Box sx={{ maxWidth: 960, mx: 'auto' }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          We use cookies and similar technologies to improve your experience. Essential cookies are
          required for the site to function. Analytics and advertising cookies help us understand
          how you use our site and measure the effectiveness of our ads. These are only enabled with
          your consent.
        </Typography>

        <Collapse in={showPreferences}>
          <Box sx={{ mb: 2, pl: 1 }}>
            <FormControlLabel
              control={<Switch checked disabled />}
              label={
                <Box>
                  <Typography variant="body2" fontWeight={500}>
                    Essential
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Required for site functionality. Cannot be disabled.
                  </Typography>
                </Box>
              }
              sx={{ mb: 1, alignItems: 'flex-start' }}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={analyticsToggle}
                  onChange={(_, checked) => {
                    setAnalyticsToggle(checked);
                  }}
                />
              }
              label={
                <Box>
                  <Typography variant="body2" fontWeight={500}>
                    Analytics & Ads
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Helps us understand site usage and measure ad effectiveness via Google.
                  </Typography>
                </Box>
              }
              sx={{ alignItems: 'flex-start' }}
            />
          </Box>
        </Collapse>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
          {showPreferences ? (
            <Button variant="contained" onClick={handleSavePreferences}>
              Save Preferences
            </Button>
          ) : (
            <>
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  setShowPreferences(true);
                }}
              >
                Manage Preferences
              </Button>
              <Button variant="outlined" onClick={rejectAll}>
                Reject All
              </Button>
              <Button variant="contained" onClick={acceptAll}>
                Accept All
              </Button>
            </>
          )}
        </Stack>
      </Box>
    </Paper>
  );
}
